<template>
    <section class="content">
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
  
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>
  
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>
  
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button type="submit" @click.prevent="searchFollowUpData"
                class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>
            
            <!-- <div class="p-field p-col-12" v-if="crmFollowUpList && crmFollowUpList.length > 0">
              <a href="#" @click.prevent="exportCSV()">
                <img src="../../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
              </a>
            </div> -->
          </div>
        </form>
        <DataTable ref="po"
        :value="crmFollowUpListDateRangeLists"
        :paginator="true"
        :rows="100" :filters="filters"
        :rowsPerPageOptions="[100, 500, 1000]"
        class="p-datatable-responsive p-datatable-customers"
        :selection.sync="selectedProduct1" selectionMode="single"
      >
      <template #header v-if="this.$store.getters.modules.includes('5.38')">
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
      <template #empty>
        <div class="flex justify-center items-center h-10 text-gray-500">
          No record found
        </div>
      </template> 
        <Column header="S.n">
          <template #body="slotProps">
          {{slotProps.index+1}}
          </template>
        </Column>
        <Column :sortable="true" header="Particular" field="particular" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['particular']" />
          </template>
        </Column>
        <Column :sortable="true" header="Client Name" field="clientName" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['clientName']" />
          </template>
        </Column>
        <Column :sortable="true"
          header="Contact Person"
          field="contactPerson"
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactPerson']" />
          </template>
        </Column>

        <Column :sortable="true" header="Address" field="address" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']" />
          </template>
        </Column>

        <Column :sortable="true" header="Contact Number" field="contactNumber"
          filterMatchMode="contains" >
          <template #body="slotProps">
          {{ formatContactNumber(slotProps.data.contactNumber) }}
        </template>
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
          </template>
        </Column>

        <Column :sortable="true" header="Remarks-Product-Rate" field="remarks" filterMatchMode="contains" >
            <template #body="slotProps">
            <Button icon="pi pi-eye" class="p-button-raised p-button-success" @click="openRemarks(slotProps.data)" />
            </template>
        </Column>

        <Column :sortable="true" header="Email" field="gmail" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['gmail']" />
          </template>
        </Column>

        <Column :sortable="true" header="Customer Type" field="customerType" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['customerType']" />
          </template>
        </Column>

        <Column :sortable="true" header="Priority" field="priority" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['priority']" />
          </template>
        </Column>

        <Column :sortable="true" header="Stage" field="stage" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['stage']" />
          </template>
        </Column>

        <Column :sortable="true" header="Sample Sent" field="sampleQuotationSent" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['sampleQuotationSent']" />
            </template>
            <template #body="slotProps">
    {{ slotProps.data.sampleQuotationSent ? 'Yes' : 'No' }}
  </template>
          </Column>

          <Column :sortable="true" header="Quotation Sent" field="quotationSent" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['quotationSent']" />
            </template>
            <template #body="slotProps">
    {{ slotProps.data.quotationSent ? 'Yes' : 'No' }}
  </template>
          </Column>

          <Column :sortable="true" header="Updated Date Np" field="updateDateNepali" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['updateDateNepali']" />
          </template>
        </Column>

          <Column :sortable="true" header="Next Follow Up Date Np" field="nextFollowUpDateNepali" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['nextFollowUpDateNepali']" />
          </template>
        </Column>

        <Column header="Enter By" :sortable="true" field="enterBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['enterBy']"/>
                </template>
        </Column>
           <Column header="Update By" :sortable="true" field="updatedBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                </template>
          </Column>
          
        <!-- <Column header="Action" headerStyle="width: 11em">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmFollowUp(slotProps.data)" />
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="openDialog(slotProps.data.id)"/>
          </template>
        </Column> -->
      </DataTable>
      </div>
      <remarksDialog
    :visible="dialogVisible"
    :style="{ width: '500px' }"
    header="Remarks"
    :modal="true"
    class="p-fluid"
  >
  <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="productName">Products <span style="color:red"></span></label>
        <Textarea
          id="productName"
          v-model="productName"
          rows="2"
          autoResize
        />
      </div>

   
      <div class="p-field p-col-12 p-md-6">
        <label for="rate">Rate <span style="color:red"></span></label>
        <Textarea
          id="rate"
          v-model="rate"
          rows="2"
          autoResize
        />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks">Remarks <span style="color:red"></span></label>
        <Textarea
          id="remarks"
          v-model="remarks"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks1">Remarks 1</label>
        <Textarea
          id="remarks1"
          v-model="remarks1"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks2">Remarks 2</label>
        <Textarea
          id="remarks2"
          v-model="remarks2"
          rows="3"
          autoResize
        />
      </div>
    </div>
    <template #footer>
      <Button
        label="Close"
        icon="pi pi-times"
        class="p-button p-button-raised p-button-danger"
        @click="closeRemarks"
      />
    </template>
  </remarksDialog>
    </section>
  </template>
  
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable/DataTable'
  import Column from 'primevue/column/Column'
  import InputText from 'primevue/inputtext/InputText'
  import MultiSelect from 'primevue/multiselect'
  import InputMask from 'primevue/inputmask'
  import Button from 'primevue/button'
  // import globalKey from '../../../store/globalKey'
  // import axios from 'axios'
  import remarksDialog from 'primevue/dialog'
  import Textarea from 'primevue/textarea'
  import $ from 'jquery'
  
  export default {
    name: 'CrmFilterComponent',
    components: {
      DatePicker,
      DataTable,
      Column,
      InputText,
      MultiSelect,
      InputMask,
      remarksDialog,
      Textarea,
      Button
    },
    data() {
      return {
        selectedCustomerTypes: [],
        crmFollowUpListDateRangeLists: [],
        filters: {},
        fromDate: null,
        selectedProduct1: null,
        toDate: null,
        loading: false,
        dialogVisible: false,
        currentProductNames: '',
        currentRate: '',
        currentRemarks: '',
        currentRemarks1: '',
        currentRemarks2: '',
        englishDateEnabled: true,
        allCustomerTypes: [
          { label: 'Hospital/pharmacy', value: 'Hospital/pharmacy' },
          { label: 'Restaurant', value: 'Restaurant' },
          { label: 'New Restaurant', value: 'New Restaurant' },
          {label: 'Oil And Gas', value: 'Oil And Gas'},
          { label: 'Mart', value: 'Mart' },
          { label: 'Khanepani', value: 'Khanepani' },
          { label: 'Suppliers', value: 'Suppliers' },
          { label: 'Cinemas', value: 'Cinemas' },
          { label: 'Other', value: 'Other' }
        ],
        filteredCustomerTypes: [],
        crmCustomerWises: []
      }
    },
    mounted() {
      this.loadUserData()
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (this.$store.getters.englishDate === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled === 'true') {
        this.setEnglishDate()
      }
    },
    methods: {
      async loadUserData() {
        await this.$store.dispatch('loadUser')
        const userId = this.$store.state.user.id
        const userData = this.$store.state.users.userLists.find(user => user.id === userId)
        if (userData) {
          this.crmCustomerWises = userData.crmCustomerWises
          this.filteredCustomerTypes = this.getFilteredCustomerTypes(this.crmCustomerWises)
        }
      },
      openRemarks(data) {
        this.remarks = data.remarks
        this.remarks1 = data.remarks1
        this.remarks2 = data.remark2
        this.dialogVisible = true
        this.productName = data.products.join(', ')
        this.rate = data.rate
      },
      closeRemarks() {
        this.dialogVisible = false
      },
      formatDate(dateString) {
        if (!dateString) return ''
        const date = new Date(dateString)
        return date.toLocaleDateString()
      },
      getFilteredCustomerTypes(userCategories) {
        if (userCategories && userCategories.length > 0) {
          return this.allCustomerTypes.filter(type => userCategories.includes(type.value))
        }
        return this.allCustomerTypes
      },
      formatContactNumber(num) {
        if (!num) return ''
        const clean = num.toString().replace(/\D/g, '').substring(0, 10)
        return clean
      },
      async searchFollowUpData() {
        if ((this.fromDate && !this.toDate) || (!this.fromDate && this.toDate)) {
          this.$toast.add({
            severity: 'warn',
            summary: '',
            detail: 'Both From Date and To Date are required',
            life: 5000
          })
          return
        }
        try {
          let params = {
            fromDate: this.fromDate,
            toDate: this.toDate
          }
          this.loading = true
          let response = await this.$store.dispatch('loadCrmFollowUpListByDateRange', params)
          if (response.data.status === 'SUCCESS' && response.data.data && response.data.data.length > 0) {
            this.crmFollowUpListDateRangeLists = response.data.data
            this.$toast.add({
              severity: 'success',
              summary: '',
              detail: 'Data loaded successfully',
              life: 3000
            })
          } else {
            this.crmFollowUpListDateRangeLists = []
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'No records found',
              life: 10000
            })
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'Failed to load follow-up data',
            life: 10000
          })
        }
      },
      // exportCSV() {
      //   let data = {
      //     fromDate: this.fromDate,
      //     toDate: this.toDate,
      //     customerTypes: this.selectedCustomerTypes.map(type => type.id).join(',')
      //   }
      //   axios({
      //     url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/crmFollowUp' + '/' + this.$store.getters.fyId + '/' + data.customerTypes,
      //     method: 'get',
      //     headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
      //     responseType: 'blob'
      //   }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
      //     const link = document.createElement('a')
      //     const contentDisposition = response.headers['content-disposition']
      //     let fileName = 'crmFollowUpDateRange.xlsx'
      //     if (contentDisposition) {
      //       const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
      //       if (fileNameMatch && fileNameMatch.length === 2) {
      //         fileName = fileNameMatch[1]
      //       }
      //     }
      //     link.href = url
      //     link.setAttribute('download', fileName)
      //     document.body.appendChild(link)
      //     link.click()
      //     link.remove()
      //     window.URL.revokeObjectURL(url)
      //   })
      // },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
        } else {
          this.englishDateEnabled = false
        }
      },
      setEnglishDate() {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .multiselect-custom, .dropdown-custom {
    font-size: 1.4rem;
    min-height: 35px;
  }
  
  .item-name {
    font-size: 1.3rem;
    margin-left: 8px;
  }
  
  ::v-deep .p-multiselect-label, 
  ::v-deep .p-dropdown-label {
    font-size: 1.3rem !important;
    padding: 0.75rem !important;
  }
  
  ::v-deep .p-multiselect-item,
  ::v-deep .p-dropdown-item {
    font-size: 1.3rem !important;
    padding: 0.75rem 1.25rem !important;
  }
  </style>



// WEBPACK FOOTER //
// crmFollowUpDateRange.vue?eb5091d6